import React, { useState } from "react";
import { Modal } from "../../../Components/Modal";
import { AdminIcon } from "../../../Icons/AdminIcon";
import '../AdminGroups.css'
import { CreateGroupDto } from "../../../Types/GroupServiceTypes";
import Loader from "../../../Components/Loader";
import { GroupService } from "../../../DataService/GroupService";

interface Props {
  onClose: () => void;
  onCreated: () => Promise<void>;
}

const CreateGroupModal: React.FC<Props> = ({ onClose, onCreated }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [emails, setEmails] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    const dto: CreateGroupDto = {
      name,
      description,
      emails: emails.split("\n").map(x => x.trim()).filter(x => x)
    };
    await GroupService.CreateGroup(dto);
    setSaving(false);
    await onCreated();
  };

  return (
    <Modal className="admin-group-modal-layout" onClose={onClose}>
      <div className="admin-group-modal-close">
        <button type="button" aria-label="Stäng" onClick={onClose}>
          <AdminIcon.CrossClose fill="hsl(var(--primary))" width={18} />
        </button>
      </div>
      <div className="sheet-header-container">
        <h2 className="sheet-header-text">Skapa ny grupp</h2>
        <p className="sheet-header-paragraph">Fyll i namn, beskrivning och eventuella email (en per rad)</p>
      </div>

      <div className="admin-group-modal-form">
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Gruppnamn</label>
        <input className="admingroups-input" value={name} onChange={e => setName(e.target.value)} />
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Beskrivning</label>
        <textarea className="admingroups-input" value={description} onChange={e => setDescription(e.target.value)} />
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Användaremails (en per rad)</label>
        <textarea className="admingroups-input" rows={6} value={emails} onChange={e => setEmails(e.target.value)} />
      </div>

      <div className="admin-group-modal-footer">
        <button className="sheet-form-submit-button" onClick={submit} disabled={saving || !name || !description}>
          {saving ? (<><Loader loaderSize="SMALL" bgColor="white" /> Sparar</>) : (<><AdminIcon.PlusSign width={16} height={16} fill="white" /> Skapa grupp</>)}
        </button>
      </div>
    </Modal>
  );
};

export default CreateGroupModal;
